import { FC } from 'react';

import FreshChatSetup from 'app/services/freshchat';
import { PropsWithOnlyChildren } from 'app/types';

const FreshChatProvider: FC<PropsWithOnlyChildren> = props => {
  return (
    <FreshChatSetup>
      {props.children}
    </FreshChatSetup>
  );
};

export default FreshChatProvider;
